import { Buffer } from 'buffer';


// host name
//TODO
const CURRENT_HOST: string | undefined = process.env.REACT_APP_BASE_URL_GRIEVANCES;

// entry path
//TODO
const BASE_PATH: string = process.env.REACT_APP_CONTEXT_PATH_GRIEVANCES ?? 'grievance';

// environment
const CURRENT_PATH: string = 'https://' + CURRENT_HOST + '/' + BASE_PATH;
const API_VERSION = '/v1.1';

// types of methods
export const method: {
  DELETE: string;
  POST: string;
  GET: string;
  PUT: string;
  PATCH: string;
  OPTIONS: string;
} = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATCH: 'PATCH',
  DELETE: 'DELETE',
  OPTIONS: 'OPTIONS',
};

//TODO
const credentials = {
  Username: '',
  Password: 'i luv Kshema',
};

// api paths
export const paths = {
  // base URL
  BASE_URL: CURRENT_PATH,
  API_VERSION,

  // Encode credentials in Base64
  basicAuthString: Buffer.from(
    `${credentials.Username}:${credentials.Password}`,
  ).toString('base64'),

  AUTHENTICATION_ENDPOINT: 'REST/authentication',
  GRIEVANCE_TYPE: '/v1.1/grievance-type',
  GRIEVANCE_SOURCE: '/v1.1/grievance-source',
  GRIEVANCE_STATUS: '/v1.1/grievance-status',
  GRIEVANCE_SEVERITY:'/v1.1/severity',
  GRIEVANCE_MODE: '/v1.1/mode',
  GRIEVANCE_FINAL_DISPOSITION: '/v1.1/grievance-final-status',
  GRIEVANCE_SEASON: '/v1.1/grievance-season',
  GRIEVANCE_LOB: '/v1.1/lob/',
  GRIEVANCE_REQUEST_TYPE: '/ServiceRequest/getAll',
  GRIEVANCE_DASHBOARD: '/v1.1/dashboard',
  GRIEVANCE_INFO: '/v1.1/grievance-info',
  GRIEVANCE_UPDATE: '/v1.1/grievance-update',
  GRIEVANCE_CREATE: '/grievance-form',
  GRIEVANCE_DOWNLOAD: '/v1.1/bulk-download',
  GRIEVANCE_DOC: '/get-grievance-docs',
  GRIEVANCE_DOC_UPLOAD: '/grievance-doc',
  STATE_MASTER: '/v1.1/state',
  DISTRICT_MASTER: '/district',
  LOCATION_DETAILS: '/location-details',
  GRIEVANCE_DEPARTMENT: '/v1.1/grievance-department',
  GRIEVANCE_PRODUCT:'/v1.1/products',
  CUSTOMER_SEARCH:'/v1.1/user-details',
  POLICY_SEARCH:'/v1.1/product-details',
  GET_ROLES: '/departments/groups-search',
  GET_PERMISSIONS: '/permissions/get-all-permissions',
  GET_USERS: '/departments/all-group-members',
  UPDATE_USER: '/departments/users/status',
  GET_USERS_BY_DEPARTMENT: '/departments/groups/members',
  GET_ALL_ROLES: '/departments/groups',
  GET_PERMISSIONS_BY_DEPARTMENT: '/groups/permission-mappings',
  UPDATE_ROLE_PERMISSIONS: '/departments/update-groups-status',
  CREATE_ROLE_PERMISSIONS: '/departments/create-groups',
  DELETE_GRIEVANCE: '/v1.1/grievance-delete',
  SESSION_GROUP: '/departments/group',
  SESSION: '/sessions',
  DOWNLOAD_ATTACHMENTS: '/download',
  BULK_ASSIGN: '/assignment/update-bulk-assignment',
  BULK_UPLOAD: '/bulkupdate/import-excel',
  BULK_UPLOAD_CPGRAM: '/upload/cpgram/import-excel',
  BULK_UPLOAD_KRPH: '/upload/krph/import-excel',
  DOWNLOAD_LOGS: '/bulkupdate/error-logs',
  DOWNLOAD_LOGS_KRPH:'/upload/krph/error-logs',
  DOWNLOAD_LOGS_CPGRAM:'/upload/cpgram/error-logs',
  DELETE_ROLE:'/role-master/group',
  DELETE_USER:'/role-master/user',
  EDIT_USER:'//role-master/group',
  GET_FEEDBACK: '/feedback',
  GRIEVANCE_DESCRIPTION: '/complaint-description',
  GRIEVANCE_DOC_UPLOADS: '/bulk/documents',
  BB_FAILURE_TICKETS: '/v1.1/bb-failure-tickets',
  BB_F_T_EXCEL: '/v1.1/bb-failure-ticket-excel'
};
